import NumeroProcesso from "./NumeroProcesso";

class UtilNumeroProcesso {

    static numeroEhCompativelComPrefixoZero(numeroProcesso: string, numeroFiltro: string) {
        const numeroProcessoSomenteDigitos = (numeroProcesso || "").toString().replace(/\D+/g, "");
        const numeroFiltroSomenteDigitos = (numeroFiltro || "").toString().replace(/\D+/g, "");
        const numeroProcessoNormalizado = numeroProcessoSomenteDigitos.replace(/^0+/, "") || "0";
        const numeroFiltroNormalizado = numeroFiltroSomenteDigitos.replace(/^0+/, "") || "0";

        if (!numeroFiltroSomenteDigitos.length) return true;
        if (numeroProcessoSomenteDigitos === numeroFiltroSomenteDigitos) return true;
        if (numeroProcessoNormalizado === numeroFiltroNormalizado) return true;
        if (numeroProcessoSomenteDigitos.length < numeroFiltroSomenteDigitos.length) return false;
        if (!numeroProcessoSomenteDigitos.endsWith(numeroFiltroSomenteDigitos)) return false;

        const prefixoOmitido = numeroProcessoSomenteDigitos.slice(0, numeroProcessoSomenteDigitos.length - numeroFiltroSomenteDigitos.length);
        return /^0*$/.test(prefixoOmitido);
    }

    static campoEhCompativelPorPrefixo(valorProcesso?: string, valorFiltro?: string) {
        const filtro = (valorFiltro || "").toString().trim();
        if (!filtro.length) return true;
        return (valorProcesso || "").toString().startsWith(filtro);
    }

    static compararNumeroProcesso(processo, numeroFiltro) {
        let retorno = true;
        const numeroProcesso = UtilNumeroProcesso.getObjetoNumeroProcesso(processo.processo.numeroCompleto);
        if (numeroFiltro && numeroProcesso) {
            let numeroComZeros;
            if (numeroFiltro.numero) {
                numeroComZeros = numeroFiltro.numero.toString();
                if (numeroComZeros.length < 7) {
                    while (numeroComZeros.length < 7) {
                        numeroComZeros = "0" + numeroComZeros;
                    }
                }
            }
            retorno = retorno && (!numeroFiltro.numero || (numeroFiltro.numero && numeroFiltro.numero === numeroProcesso.numero) || numeroProcesso.numero === numeroComZeros || numeroProcesso.numero.indexOf(numeroFiltro.numero) > -1);
            retorno = retorno && (!numeroFiltro.digito || (numeroFiltro.digito && numeroFiltro.digito === numeroProcesso.digito));
            retorno = retorno && (!numeroFiltro.ano || (numeroFiltro.ano && numeroFiltro.ano === numeroProcesso.ano));
            retorno = retorno && (!numeroFiltro.orgao || (numeroFiltro.orgao && numeroFiltro.orgao === numeroProcesso.orgao));
            retorno = retorno && (!numeroFiltro.regional || (numeroFiltro.regional && numeroFiltro.regional === numeroProcesso.regional));
            retorno = retorno && (!numeroFiltro.vara || (numeroFiltro.vara && numeroFiltro.vara === numeroProcesso.vara));
        }
        return retorno;
    }

    static getObjetoNumeroProcesso(numeroProcesso) {
        const NUMERO_PROCESSO_PATTERN = /([0-9]+)[.-]([0-9]+).([0-9]+).([0-9]+).([0-9]+).([0-9]+)/;
        const match = NUMERO_PROCESSO_PATTERN.exec(numeroProcesso);
        if (match !== null) {
            return {
                numero: match[1],
                digito: match[2],
                ano: match[3],
                orgao: match[4],
                regional: UtilNumeroProcesso.preencheZeros(match[5], 2),
                vara: UtilNumeroProcesso.preencheZeros(match[6], 4)
            };
        }
    }

    static NUMERO_PROCESSO_PATTERN = /^(\d+)[.-](\d{2})\.(\d{4})\.(\d{1})\.(\d{2})\.(\d{4})$/;

    static matchObjetoNumeroProcesso = (numeroProcesso: string) => {
        const classe = numeroProcesso.split(" - ")[0] || "";
        const numeroSemClasse = numeroProcesso.includes(" - ")
            ? numeroProcesso.split(" - ").slice(1).join(" - ")
            : numeroProcesso;
        const match = UtilNumeroProcesso.NUMERO_PROCESSO_PATTERN.exec(numeroSemClasse.trim());
        const numeroCompacto = numeroSemClasse.replace(/\D+/g, "");

        if (match) {
            const [_, numero, digito, ano, justica, tribunal, vara] = match;

            const tribunalFmt = UtilNumeroProcesso.preencheZeros(tribunal, 2);
            const varaFmt = UtilNumeroProcesso.preencheZeros(vara, 4);

            return {
                numeroCompleto: `${numero}-${digito}.${ano}.${justica}.${tribunalFmt}.${varaFmt}`,
                numero, digito, ano, justica,
                tribunal: tribunalFmt, vara: varaFmt, classe, validoFormato: true
            };
        }

        if (numeroCompacto.length === 20) {
            const numero = numeroCompacto.substring(0, 7);
            const digito = numeroCompacto.substring(7, 9);
            const ano = numeroCompacto.substring(9, 13);
            const justica = numeroCompacto.substring(13, 14);
            const tribunal = numeroCompacto.substring(14, 16);
            const vara = numeroCompacto.substring(16, 20);

            return {
                numeroCompleto: `${numero}-${digito}.${ano}.${justica}.${tribunal}.${vara}`,
                numero, digito, ano, justica,
                tribunal, vara, classe, validoFormato: true
            };
        }

        const numeroParcialPattern = /^(\d+)(?:-(\d*))?(?:\.(\d*))?(?:\.(\d*))?(?:\.(\d*))?(?:\.(\d*))?$/;
        const parcialMatch = numeroParcialPattern.exec(numeroSemClasse.trim());

        if (!parcialMatch) {
            return {
                numeroCompleto: "",
                numero: "", digito: "", ano: "", justica: "",
                tribunal: "", vara: "", classe, validoFormato: false
            };
        }

        const [, numero, digito = "", ano = "", justica = "", tribunalInformado = "", varaInformada = ""] = parcialMatch;
        const tribunal = tribunalInformado;
        const vara = varaInformada;

        return {
            numeroCompleto: `${numero}-${digito}.${ano}.${justica}.${tribunal}.${vara}`,
            numero: numero.trim(), digito, ano, justica,
            tribunal, vara, classe, validoFormato: true
        };
    };

    static extrairNumerosProcessoDeTexto = (texto: string): string[] => {
        if (!texto?.trim()) {
            return [];
        }

        const resultado: string[] = [];
        const vistos = new Set<string>();
        const patternCompleto = /(?:^|\D)(\d{1,7}[-.]\d{2}\.\d{4}\.\d\.\d{2}\.\d{4}|\d{20})(?=\D|$)/g;
        const patternParcial = /(?:^|[^\d.-])(\d{7}(?:-\d{1,2})?(?:\.\d{1,4})?(?:\.\d{1})?(?:\.\d{1,2})?(?:\.\d{1,4})?)(?=$|[^\d.-])/g;
        const patternCompactoParcial = /(?:^|\D)(\d{7,19})(?=\D|$)/g;
        const textoFonte = texto.toString();
        let encontrouNumeroCompleto = false;
        let match = patternCompleto.exec(textoFonte);

        while (match !== null) {
            const numeroEncontrado = match[1];
            const numeroProcesso = UtilNumeroProcesso.matchObjetoNumeroProcesso(numeroEncontrado);

            if (numeroProcesso?.validoFormato && numeroProcesso.numeroCompleto) {
                if (!vistos.has(numeroProcesso.numeroCompleto)) {
                    resultado.push(numeroProcesso.numeroCompleto);
                    vistos.add(numeroProcesso.numeroCompleto);
                }
                encontrouNumeroCompleto = true;
            }

            match = patternCompleto.exec(textoFonte);
        }

        if (encontrouNumeroCompleto) {
            return resultado;
        }

        match = patternParcial.exec(textoFonte);
        while (match !== null) {
            const numeroEncontrado = (match[1] || "").trim();
            const isCompleto =
                UtilNumeroProcesso.NUMERO_PROCESSO_PATTERN.test(numeroEncontrado) ||
                /^\d{20}$/.test(numeroEncontrado);

            if (!isCompleto) {
                const numeroProcesso = UtilNumeroProcesso.matchObjetoNumeroProcesso(numeroEncontrado);
                if (numeroProcesso?.validoFormato && !vistos.has(numeroEncontrado)) {
                    resultado.push(numeroEncontrado);
                    vistos.add(numeroEncontrado);
                }
            }

            match = patternParcial.exec(textoFonte);
        }

        match = patternCompactoParcial.exec(textoFonte);
        while (match !== null) {
            const numeroCompactoParcial = (match[1] || "").trim();
            const indiceNumeroNoMatch = match[0].indexOf(numeroCompactoParcial);
            const inicioNumero = match.index + (indiceNumeroNoMatch >= 0 ? indiceNumeroNoMatch : 0);
            const fimNumero = inicioNumero + numeroCompactoParcial.length;
            const caractereAnterior = inicioNumero > 0 ? textoFonte[inicioNumero - 1] : "";
            const caracterePosterior = fimNumero < textoFonte.length ? textoFonte[fimNumero] : "";

            const fazParteDeNumeroHifenizadoOuPontuado = caractereAnterior === "-" || caractereAnterior === "." || caracterePosterior === "-" || caracterePosterior === ".";
            if (fazParteDeNumeroHifenizadoOuPontuado) {
                match = patternCompactoParcial.exec(textoFonte);
                continue;
            }

            const numeroParcial = UtilNumeroProcesso.converterCompactoParcialParaFormatado(numeroCompactoParcial);
            const numeroProcesso = UtilNumeroProcesso.matchObjetoNumeroProcesso(numeroParcial);

            if (numeroProcesso?.validoFormato && !vistos.has(numeroParcial)) {
                resultado.push(numeroParcial);
                vistos.add(numeroParcial);
            }

            match = patternCompactoParcial.exec(textoFonte);
        }

        return resultado;
    };

    static converterCompactoParcialParaFormatado = (numeroCompactoParcial: string): string => {
        const digitos = (numeroCompactoParcial || "").replace(/\D+/g, "");
        if (digitos.length <= 7) {
            return digitos;
        }

        const numero = digitos.slice(0, 7);
        const digito = digitos.slice(7, 9);
        const ano = digitos.slice(9, 13);
        const justica = digitos.slice(13, 14);
        const tribunal = digitos.slice(14, 16);
        const vara = digitos.slice(16, 20);

        let retorno = numero;
        if (digito.length > 0) {
            retorno += `-${digito}`;
        }
        if (ano.length > 0) {
            retorno += `.${ano}`;
        }
        if (justica.length > 0) {
            retorno += `.${justica}`;
        }
        if (tribunal.length > 0) {
            retorno += `.${tribunal}`;
        }
        if (vara.length > 0) {
            retorno += `.${vara}`;
        }

        return retorno;
    };


    static preencheZeros(texto: any, tamanho: number) {
        const str = texto == null ? "" : texto.toString();
        return str.padStart(tamanho, "0");
    }


    static isNumero(n) {
        return /\d+/g.test(n);
    }

    static numeroProcessoSemFase(numeroProcesso: string) {
        const numProc = NumeroProcesso.valueOf(numeroProcesso);
        return numProc.semFase().numeroProcessoFormatado();
    }
}

export default UtilNumeroProcesso;
